var e=e=>e?"Помилка створення":"Помилка редагування";export{e as getDefaultErrorMessage};
//# sourceMappingURL=getDefaultErrorMessage.js.map